import EnterprisePropertyModel  from 'Models/directory/EnterprisePropertyModel';
import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { Timestampable }        from 'helpers/traits';
import { Blamable }             from 'helpers/traits';
import DirectoryPrivateApiModel from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.staticLabel('CountryEnterpriseProperty')
@model.urnResource('country_enterprise_property')
@doc.path('/country_enterprise_properties/{?id}')
export default class CountryEnterprisePropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'country': id;
		'enterpriseProperty': id;
		'enterpriseProperty.reference': DirectoryEnterprisePropertyReference;
		'enterpriseTypeCountryEnterpriseProperties': id;
		'enterpriseTypeCountryEnterpriseProperties.enterpriseType': id;
		'enterpriseTypeCountryEnterpriseProperties.enterpriseType.reference': DirectoryEnterpriseTypeReference;
		'enterpriseTypeCountryEnterpriseProperties.required': '0' | '1';
		'isUnique': '0' | '1';
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.string declare country: string;
	@doc.model(EnterprisePropertyModel) declare enterpriseProperty: EnterprisePropertyModel;
	@doc.boolean declare isUnique: boolean;
	@doc.boolean declare unique: boolean;
}